import toFixedValue, { fromFixedValue } from 'app/common/lib/toFixedValue'
import { useEncashmentsAction } from 'app/dataProviders/encashments/hooks'
import { useReportResult } from 'app/dataProviders/reports/hooks'
import { EncashmentsStatusType, ReportEncashmentsData, TotalEncashmentsSummaryType } from 'app/dataTypes/reports/data'
import { EncashmentsAction, EncashmentsStatusAction, OperationResultType } from 'app/dataTypes/reports/data/finances/encashments/action'
import { FinanceReportType } from 'app/dataTypes/reports/finances'
import { useCallback, useEffect, useState } from 'react'


const calculate = (totalSummary: TotalEncashmentsSummaryType, result: OperationResultType) => {
  const { statuses } = totalSummary
  let deltaAccept = 0
  let deltaRefused = 0
  if (result.operationType === EncashmentsAction.Accept) {
    deltaAccept = result.sum
  } else {
    deltaRefused = result.sum
  }

  const { waitingForCash, cashAccepted, cashRefused } = statuses
  const waitingForCashNum = fromFixedValue(waitingForCash) ?? 0
  const cashAcceptedNum = fromFixedValue(cashAccepted) ?? 0
  const cashRefusedNum = fromFixedValue(cashRefused) ?? 0

  const newTotalSummary: TotalEncashmentsSummaryType = {
    ...totalSummary,
    statuses: {
      ...statuses,
      waitingForCash: toFixedValue(waitingForCashNum - result.sum),
      cashAccepted: toFixedValue(cashAcceptedNum + deltaAccept),
      cashRefused: toFixedValue(cashRefusedNum + deltaRefused),
    }
  }
  return newTotalSummary
}

export const useDataResult = (reportID: string | null) => {
  const [data, setData] = useState<ReportEncashmentsData | null>(null)
  const handleChange = useEncashmentsAction()
  const { requestResult, data: resultData, loading } = useReportResult(reportID, FinanceReportType.Encashments)

  const handleChangeStatus = useCallback(async (params: EncashmentsStatusAction) => {
    const res = await handleChange(params)
    if (!res || !data) return false
    const updatedData = data.rows.map((row) => {
      if (row.encashmentsSummary.salePointId === params.salePointId) {
        const newStatus = params.action === EncashmentsAction.Accept ? EncashmentsStatusType.CashAccepted : EncashmentsStatusType.CashRefused
        const updatedRow = {
          ...row,
          encashmentsSummary: {
            ...row.encashmentsSummary,
            status: newStatus,
            comment: params.comment ?? null
          }
        }
        return updatedRow
      }
      return row
    })
    setData({
      ...data,
      rows: updatedData,
      totalSummary: calculate(data.totalSummary, res)
    })
    return !!res
  }, [handleChange, data])


  useEffect(() => {
    setData(resultData)
  }, [resultData])

  return {
    requestResult,
    handleChangeStatus,
    data,
    loading
  }
}
